import { useEffect, useState } from "react";
import { BRAND, api } from "@/lib/api";
import { Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import EmailCopy from "@/components/EmailCopy";

export default function Footer() {
  const [content, setContent] = useState({});
  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data || {})).catch(() => {});
  }, []);
  const quote = content["footer.quote"] || "For God so loved the world that he gave his one and only Son, that whoever believes in him shall not perish but have eternal life.";
  const quoteRef = content["footer.quote_ref"] || "John 3:16";

  return (
    <footer
      data-testid="site-footer"
      className="bg-navy-deep text-cream/90 mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={BRAND.logoUrl}
                alt="A Mindful Space"
                className="h-14 w-14 rounded-full object-cover bg-black/30 p-0.5"
              />
              <div>
                <div className="font-serif text-2xl">A Mindful Space</div>
                <div className="text-[11px] uppercase tracking-[0.22em] text-teal-mist">
                  Counselling · Tasmania
                </div>
              </div>
            </div>
            <p className="text-cream/75 max-w-md leading-relaxed font-light">
              Compassionate online and face-to-face counselling with {BRAND.counsellor},
              based in Sorell, Tasmania.
            </p>
            <div className="mt-6 inline-flex items-center gap-3 text-xs text-cream/70 bg-cream/5 border border-cream/15 rounded-full pl-3 pr-4 py-2">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-mist" />
              <span className="uppercase tracking-[0.18em]">ACA Member</span>
              <span className="text-cream/50">·</span>
              <span className="font-mono text-teal-mist">#86410</span>
            </div>
          </div>

          <div>
            <div className="font-serif text-lg mb-4 text-teal-mist">Explore</div>
            <ul className="space-y-2 text-sm">
              <li><a href="/#meet-jesse" className="hover:text-teal-mist transition-colors">Meet Jesse</a></li>
              <li><a href="/#faith" className="hover:text-teal-mist transition-colors">Faith</a></li>
              <li><a href="/#services" className="hover:text-teal-mist transition-colors">Services</a></li>
              <li><a href="/#areas" className="hover:text-teal-mist transition-colors">Areas of support</a></li>
              <li><a href="/#locations" className="hover:text-teal-mist transition-colors">Locations</a></li>
              <li><Link to="/book" className="hover:text-teal-mist transition-colors">Book a Session</Link></li>
              <li><a href="/#enquiry" className="hover:text-teal-mist transition-colors">Enquire</a></li>
            </ul>
          </div>

          <div>
            <div className="font-serif text-lg mb-4 text-teal-mist">Connect</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <EmailCopy
                  email={BRAND.email}
                  tone="dark"
                  testid="footer-email"
                />
              </li>
              <li className="flex items-start gap-2">
                <Phone size={16} className="mt-0.5 text-teal-mist" />
                <span>{BRAND.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 text-teal-mist" />
                <span>{BRAND.region}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-cream/15 flex flex-col md:flex-row justify-between gap-4 text-xs text-cream/50">
          <div>© {new Date().getFullYear()} A Mindful Space Counselling. All rights reserved.</div>
          <div className="md:text-right md:max-w-xl" data-testid="footer-quote">
            <div className="italic font-serif text-[15px] leading-relaxed text-teal-mist/90">
              &ldquo;{quote}&rdquo;
            </div>
            <div className="mt-1 text-[10px] uppercase tracking-[0.24em] text-cream/45">
              {quoteRef}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
